package com.arena_web.data.api

import com.arena_web.data.dto.*
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import com.arena_web.data.http.apiPut
import io.ktor.client.*

class NotificationApi(private val client: HttpClient) {

    suspend fun getNotifications(params: Map<String, String> = emptyMap()): ApiResponse<NotificationsPageDto> {
        return client.apiGet("v1/notifications", params)
    }

    suspend fun markAsRead(notificationId: String): ApiResponse<Unit> {
        return client.apiPut("v1/notifications/$notificationId/read", Unit)
    }

    suspend fun markAllAsRead(): ApiResponse<Unit> {
        return client.apiPut("v1/notifications/read-all", Unit)
    }
}
